import { message } from 'antd';
import { Button, GridImage, LockStatus } from 'components';
import {
  KY_DATA_APPROVED_SITE_MANAGER,
  STATUS_KY_APPROVE,
  STATUS_LOCKED,
  userRole,
} from 'constant';
import { layoutSelector } from 'containers/Layout/selectors';
import { useAppDispatch } from 'hooks';
import { setLocationDTCAgent } from 'pages/Home/Bo/BusinessDetail/slice';
import { userData } from 'pages/Login/selectors';
import { removeImg, toggleCheckImg, updateManyImg } from 'pages/SiteDetail/slice';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { albumsService, siteService } from 'services';
// 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 start
// import { GetDetailImageResponse, GetWorkerType, ImageAlbum } from 'types';
import { GetDetailImageResponse, GetPerformanceWorkerType, ImageAlbum } from 'types';
// import { getWorkType } from '../../../../services/worker';
import { uniqBy } from 'lodash';
import { getPerformanceWorkType } from '.././thunk';
// 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 end
import { ConfirmDeleteModal, ConfirmUploadModal, DetailImageModal } from './Modals';
import SectionStyled from './styles';

type Props = {
  images: ImageAlbum[];
  loading?: boolean;
  detailImage: GetDetailImageResponse | null;
  setDetailOneImage?: (args: number | null) => void;
  setLoadingOneImage: (args: boolean) => void;
  loadingOneImage: boolean;
};

const Albums: FC<Props> = ({
  images,
  detailImage,
  loadingOneImage,
  setLoadingOneImage,
  setDetailOneImage,
}) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [showChecked, setShowChecked] = useState(false);
  const [dataModalImage, setDataModalImage] = useState<ImageAlbum | null>(null);
  const [visibleModalDelete, setVisibleModalDelete] = useState(false);
  const [visibleModalUpload, setVisibleModalUpload] = useState(false);
  const [visibleModalImage, setVisibleModalImage] = useState(false);
  const { roleUser } = useSelector(userData);
  const { LockStatusData, KYDataApproveBySiteManageDate } = useSelector(layoutSelector);
  // 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 start
  // const [dataWorker, setDataWorker] = useState<GetWorkerType[]>([]);
  const [dataWorker, setDataWorker] = useState<GetPerformanceWorkerType[]>([]);

  // 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 start
  const listIdImageSelected = useMemo(
    () => images.filter(({ isSelected }) => isSelected).map(({ image_id }) => image_id),
    [images]
  );
  const handleSelect = useCallback(
    (id: number, isSelected: boolean) => {
      dispatch(toggleCheckImg({ id, isSelected }));
      dispatch(setLocationDTCAgent(location.state));
    },
    [dispatch, location]
  );
  const handleClickImage = useCallback(
    async (image: ImageAlbum) => {
      try {
        setLoadingOneImage(true);
        if (setDetailOneImage) {
          setDetailOneImage(image.image_id);
        }
        !showChecked && setVisibleModalImage(true);
        setDataModalImage(image);
        setTimeout(() => setLoadingOneImage(false), 4000);
      } catch (e) {
        setLoadingOneImage(false);
      }
    },
    [setDetailOneImage, setLoadingOneImage, showChecked]
  );

  const handleDelete = async () => {
    const deleteImageId = images
      .filter(({ isSelected }) => isSelected)
      .map((value) => {
        return {
          image_id: Number(value.image_id),
        };
      });
    const listImgDelete = deleteImageId && deleteImageId.map((item) => item.image_id);
    await albumsService.deleteImage({ images: deleteImageId }).then(() => {
      dispatch(removeImg({ ids: listImgDelete }));
    });
    setVisibleModalDelete(false);
  };
  const key = 'updatable';

  useEffect(() => {
    (async () => {
      // 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 start
      // const { data } = await getWorkType({});
      const workType = await dispatch(
        getPerformanceWorkType({
          site_id: LockStatusData?.site_id,
        })
      );
      if (getPerformanceWorkType.fulfilled.match(workType)) {
        const data = uniqBy(workType.payload.major_construction_list, 'major_construction_id').map(
          (m) => ({
            major_construction_id: m.major_construction_id,
            major_construction_name: m.major_construction_name,
          })
        );
        setDataWorker(data);
      }
      // setDataWorker(data);
      // 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 end
    })();
    // 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 start
    // }, []);
  }, [dispatch, LockStatusData?.site_id]);
  // 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 end

  const handUploadImages = async () => {
    const idUpload = images
      .filter(({ isSelected }) => isSelected)
      .map((value) => {
        return Number(value.image_id);
      });

    try {
      if (idUpload) {
        const { data } = await siteService.uploadImages({ image_id: idUpload });
        if (data.success.length > 0 && data.errors.length === 0) {
          setTimeout(() => {
            message.success({
              content: 'アップロードに成功しました！',
              key,
              duration: 2,
              style: {
                marginTop: '90vh',
                marginBottom: '16px',
              },
            });
          }, 1000);
        } else if (data.success.length > 0 && data.errors.length > 0) {
          setTimeout(() => {
            message.info({
              content:
                '一部写真のアップロードに失敗しました エ程内検査写真以外はアップロードできません!',
              key,
              duration: 2,
              style: {
                marginTop: '90vh',
                marginBottom: '16px',
              },
            });
          }, 1000);
        } else {
          setTimeout(() => {
            message.error({
              content: 'アップロードに失敗しました!',
              key,
              duration: 2,
              style: {
                marginTop: '90vh',
                marginBottom: '16px',
              },
            });
          }, 1000);
        }
      }
    } catch (e) {
      setTimeout(() => {
        message.error({
          content: 'アップロードに失敗しました!',
          key,
          duration: 2,
          style: {
            marginTop: '90vh',
            marginBottom: '16px',
          },
        });
      }, 1000);
    }
  };

  return (
    <SectionStyled>
      <div className="container">
        <LockStatus
          text={LockStatusData?.site_name}
          roleStatus={{
            text:
              KYDataApproveBySiteManageDate?.[
                userRole.DTC === roleUser
                  ? `site_director_approval_flag`
                  : `site_manager_approval_flag`
              ] === KY_DATA_APPROVED_SITE_MANAGER.true
                ? 'RKY承認済'
                : 'RKY未承認',
            lock:
              KYDataApproveBySiteManageDate?.[
                userRole.DTC === roleUser
                  ? `site_director_approval_flag`
                  : `site_manager_approval_flag`
              ] === STATUS_KY_APPROVE.true,
          }}
          lockStatus={{
            text: LockStatusData?.status_locked === STATUS_LOCKED.true ? '施錠済' : '未施錠',
            lock: LockStatusData?.status_locked === STATUS_LOCKED.true,
          }}
          code={LockStatusData?.building_code}
        />
        <div className="header">
          <Button
            className="btn-chose-img btn"
            onClick={() => {
              const dataSetFalseListIdImageSelected = listIdImageSelected.map((item) => ({
                id: item,
                changes: { isSelected: false },
              }));
              dataSetFalseListIdImageSelected.length > 0 &&
                dispatch(updateManyImg({ data: dataSetFalseListIdImageSelected }));
              setShowChecked(!showChecked);
            }}
          >
            {showChecked ? '選択をキャンセル' : '写真を選択する'}
          </Button>
          {showChecked && (
            <>
              <div className="box-action">
                <Button
                  className="btn-delete btn"
                  disabled={listIdImageSelected.length <= 0}
                  onClick={() => setVisibleModalDelete(true)}
                >
                  削除
                </Button>
                {/* 2023/02/06 Leading Win 写真機能対応 DXWEBTPG00100_写真アルバム start */}
                {/* <Button
                  className="btn-upload btn"
                  disabled={listIdImageSelected.length <= 0}
                  onClick={() => setVisibleModalUpload(true)}
                >
                  アップロード
                </Button> */}
                {/* 2023/02/06 Leading Win 写真機能対応 DXWEBTPG00100_写真アルバム end */}
              </div>
            </>
          )}
        </div>
        {!!images.length && (
          <GridImage
            data={images}
            showChecked={showChecked}
            onSelect={handleSelect}
            onClickImage={handleClickImage}
          />
        )}
      </div>
      <ConfirmDeleteModal
        visible={visibleModalDelete}
        onOk={() => {
          handleDelete();
          setVisibleModalDelete(false);
        }}
        onCancel={() => setVisibleModalDelete(false)}
      />
      <ConfirmUploadModal
        visible={visibleModalUpload}
        onOk={() => {
          handUploadImages();
          setVisibleModalUpload(false);
        }}
        onCancel={() => setVisibleModalUpload(false)}
      />
      {/* <ToastContainer /> */}
      <DetailImageModal
        detailImage={detailImage}
        visible={visibleModalImage}
        onClickCompose={() => {
          setVisibleModalImage(false);
        }}
        onClickCut={() => {
          setVisibleModalImage(false);
        }}
        data={dataModalImage}
        showModal={setVisibleModalImage}
        images={images}
        setLoadingOneImage={setLoadingOneImage}
        loadingOneImage={loadingOneImage}
        dataWorker={dataWorker}
      />
    </SectionStyled>
  );
};

export default Albums;
